export function isInteger(n: number): boolean {
  return Number(n) === n && n % 1 === 0;
}
